import {RemoveBag, RemoveBagCallback, RemoveBagContractModel} from "@next/eventservice"
import {ShoppingBagApiPost} from "../../api/shoppingbag"

const getBagESB = new RemoveBag()
const getBagCallbackESB = new RemoveBagCallback()

export const SubscribeToShoppingBagRemove = (siteUrl: string) => {
    getBagESB.subscribe(data => {
        LoadApiData(siteUrl, data)
    })
}

class BagRemoveApiModel {
    id = ""
    customItemType = ""
}

const LoadApiData = (url: string, data: RemoveBagContractModel) => {
    const apiModel = new BagRemoveApiModel()
    apiModel.id = data.id
    apiModel.customItemType = data.customItemType || ""

    ShoppingBagApiPost(apiModel, `${url}/bag/Remove`, getBagCallbackESB, data.eventId)
}
